<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Team Selection</h4>
</div>

<div class="modal-body" *ngIf="teamList">
    <ul class="list--bulletless--content">
        <li *ngFor="let team of teamList; let indexValue = index">
            <label class="mvd_label--inline"><input type="checkbox" value="{{team.id}}" [checked]="team['selected']" (click)="selectionMade($event)" /> {{team.teamDisplayValue}}</label>
        </li>
    </ul>
    <h2 class="mvd_alert--label" *ngIf="teamList.length === 0">No Teams Available</h2>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <input class="btn--primary" type="button" value="Done" (click)="done()" />
    </div>
</div>
